export default {
  headerContent: {
    title: 'Sompo Sigorta İş Yeri Sigortası Hesaplama',
    slogan: "İş Yeri Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'İŞ YERİ SİGORTASI TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'Sompo Sigorta İş Yeri Sigortası',
    description: {
      title: 'Sompo Sigorta İş Yeri (Paket) Sigortası Nedir? ',
      content: [
        'İş yeri sigortası, işletmede oluşacak yangın, hırsızlık gibi hasarların meydana gelmesi sonucunda oluşacak finansal kayıplara karşı koruma sağlamaktadır. ',
        'Sompo Sigorta iş yeri sigortası ile sağladığı koruma sayesinde hem işletme sahibini hem de çalışanları kapsadığı gibi 3. Şahıslarında uğrayacağı zararları da güvence altına almaktadır.'
      ]
    },
    subContent: {
      title: 'Sompo Sigorta İş Yeri (Paket) Sigortası Teminatları Nedir?',
      content: [
        {
          paragraph:
            'Sompo Sigorta teminatları ana ve ek olmak üzere 2’ye ayrılmaktadır.',
          subList: null
        },
        {
          paragraph: '<strong>Ana teminatlar;</strong>',
          subList: [
            'Yangın, Yıldırım, İnfilak',
            'Fırtına',
            'Dâhili Su',
            'Kara Taşıtları Çarpması',
            'Hava Taşıtları Çarpması',
            'Enkaz Kaldırma Masrafları',
            'Duman',
            'Yer Kayması',
            'Temeller',
            'Kar Ağırlığı',
            'Grev, Lokavt, Kargaşa, Halk Hareketleri, Kötü Niyetli Hareketler, Terör',
            'Yangın Sorumluluk (Kiracı/Malik, Komşuluk)',
            'Kiracının-Malikin Kira Kaybı',
            'Alternatif İş Yeri Masrafları',
            'İş Yeri Binasındaki Sabit Kıymetlerdeki Hırsızlık',
            'Geçici Adres Nakli',
            'İş Durması',
            'Dolu '
          ]
        },
        {
          paragraph: '<strong>Ek teminatlar;</strong>',
          subList: [
            'Deprem Ve Yanardağ Püskürmesi',
            'Deniz Taşıtları Çarpması',
            'Sel-Su Baskını',
            'Hırsızlık',
            'Reçete Ve Kupür Hırsızlık',
            'Cam Kırılması',
            'Emniyeti Suistimal',
            'Test Sürüşleri',
            'Taşınan Para',
            'Makine Kırılması (İlk Ateş Esası İle)',
            'Soğutucu Cihazlarda Ürün Bozulması',
            'Elektronik Cihaz (İlk Ateş Esası İle)',
            'Elektrik Hasarları',
            'Yeni Değer Klozu',
            '3. Şahıs Mali Mesuliyet (Lift Kullanımı Dâhil)',
            'Mesleki Mesuliyet (Eczane Faaliyet Kolu İçin)',
            'İşveren Mali Mesuliyet',
            'Eksik Sigorta',
            'Yeni Yatırımlar',
            'Arızi İnşaat İşleri ',
            'İzolasyon Eksikliği',
            'Fiziki Zararlar',
            'Kasa Hırsızlık',
            'Nakliye Emtia'
          ]
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'İş Yeri Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'İş Yeri Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'İş Yeri Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'İş Yeri Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'İş Yeri Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'Sompo Sigorta İş Yeri Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.'
}
